import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './VoucherAppointmentsTranslate';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import {
  voucherAppointmentsModule,
  clearState,
  prolongVoucher,
  appointmentDownload,
  loadAppointments,
  declineVoucher, canGetVoucher
} from './VoucherAppointmentsDucks';
import StaticTablePaginated from '../../_ui/Table/StaticTablePaginated';
import i18n from 'i18next';
import { StyledCardsContainer } from './VoucherAppointmentsStyle';
import { requestsColumns } from './TableColumns/TableColumns';
import useModal from '../../modules/_hooks/useModal';
import DialogComponent from '../../components/DialogComponent/DialogComponent';
import { useHistory } from 'react-router-dom';

function VoucherAppointments() {
  const { t } = useTranslation();
  const { push } = useHistory();
  const dispatch = useDispatch();
  const { data, pageNumber, totalElements, loading } = useSelector(
    state => state[voucherAppointmentsModule]
  );
  const modalProlong = useModal('prolongVoucher');
  const modalDeclineVoucher = useModal('modalDeclineVoucher');

  const loadData = filter => dispatch(loadAppointments(filter));

  const { toPage, filter } = useTableFilter(loadData, '', {
    pageNumber: 1,
    pageSize: 10
  });

  const handleDone = async () => {
    dispatch(prolongVoucher(modalProlong.data.id, modalProlong, filter));
  };
  const handleDoneDeclineVoucher = async () => {
    dispatch(declineVoucher(modalDeclineVoucher.data, modalDeclineVoucher, filter));
  };
  const downloadAppointments = requestFormId => {
    dispatch(appointmentDownload({ requestFormId }));
  };
  const checkBulletins = data => {
    dispatch(canGetVoucher(data, push));
  };


  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  return (
    <div className="mb3 mt3" style={{ width: '100%' }}>
      <Typography
        children={t('voucher_appointments_subtitle')}
        color="secondary"
        variant="h6"
        style={{ paddingLeft: '10px' }}
      />

      <StyledCardsContainer>
        <StaticTablePaginated
          TheadComponent={_ => null}
          pageNumber={pageNumber}
          loading={loading}
          data={data}
          totalElements={totalElements}
          columns={requestsColumns({
            t,
            filter,
            pageNumber,
            lang: i18n.language,
            modalProlong,
            downloadAppointments,
            modalDeclineVoucher,
            checkBulletins
          })}
          filterable={false}
          pageSize={10}
          pagePagination={page => {
            if (page !== pageNumber) {
              toPage(page);
            }
          }}
        />
        <DialogComponent
          modalBody={t('voucher_applications_modalBodyProlong')}
          modalTitle={t('voucher_applications_modalTitleProlong')}
          open={modalProlong.isOpen}
          handleClose={modalProlong.close}
          handleDone={handleDone}
          loading={loading}
        />
        <DialogComponent
          modalBody={t('voucher_applications_modalBodyDeclineVoucher')}
          modalTitle={t('voucher_applications_modalTitleDeclineVoucher')}
          open={modalDeclineVoucher.isOpen}
          handleClose={modalDeclineVoucher.close}
          handleDone={handleDoneDeclineVoucher}
          loading={loading}
        />
      </StyledCardsContainer>
    </div>
  );
}

export default VoucherAppointments;
